export default {
  message_not_edited_error: 'Message was not saved. Please try again.',
  CANCEL: 'Cancel',
  SAVING: 'Saving',
  generic_save: 'Save',
};
